// extracted by mini-css-extract-plugin
module.exports = {"root":"Signup_root__8sVQ7","button_container":"Signup_button_container__36Uid","link":"Signup_link__2BTCJ","signup":"Signup_signup__3Lx8t","message":"Signup_message__2laTa"};